import { render, staticRenderFns } from "./HNotice.vue?vue&type=template&id=3ed59dc5&scoped=true&"
import script from "./HNotice.vue?vue&type=script&lang=js&"
export * from "./HNotice.vue?vue&type=script&lang=js&"
import style0 from "./HNotice.vue?vue&type=style&index=0&id=3ed59dc5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed59dc5",
  null
  
)

export default component.exports